// Figma: 6086:28468 — see stories/blocks/customers-grid-animated-logo.stories.tsx
"use client";

import { AnimatePresence, motion } from "framer-motion";

import {
  getLogoMotionVariants,
  getLogoSlideOffset,
} from "./customers-grid-animation";
import type { CustomersGridMotionVariant } from "./customers-grid-animation";
import type { CustomerLogoId } from "./customers-grid-catalog";
import { getCustomerLogoEntry } from "./customers-grid-catalog";

interface CustomersGridAnimatedLogoProps {
  logoId: CustomerLogoId;
  variant: CustomersGridMotionVariant;
  className?: string;
}

export function CustomersGridAnimatedLogo({
  logoId,
  variant,
  className,
}: CustomersGridAnimatedLogoProps) {
  const { logo, name } = getCustomerLogoEntry(logoId);

  return (
    <div className={className ?? "relative h-full w-full overflow-hidden"}>
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={logoId}
          className="absolute inset-0 flex items-center justify-center will-change-[opacity,transform]"
          variants={getLogoMotionVariants(getLogoSlideOffset(variant))}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          <img
            src={logo.src}
            alt={name}
            width={logo.width}
            height={logo.height}
          />
        </motion.span>
      </AnimatePresence>
    </div>
  );
}
